import React from 'react'
import { ColumnRank, ColumnName, ColumnExpander, ColumnResult } from "components/common/TableColumns"
import { Label } from 'pages/About'
import { NocMemo } from 'components/presentation/Noc'

function ColumnNoc({

    disableSort = false,
    className = 'text-start d-md-table-cell ',
    headerClassName = 'text-start d-md-table-cell align-middle',
    label = 'HeaderNOC',
    remove = false,
    longDesc = false
}) {

    return (
        {
            Header: <Label data={label} />,
            id: 'NOC',
            accessor: 'organisation.code',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            remove: remove,
            Cell: (props) => {
                const row = props.cell.row.original
                return (<NocMemo {...row?.organisation} showLongDesc={true} />)
            }
        }
    )

}


export function TableColumns() {

    let columns = [
        ColumnRank({}),
        ColumnNoc({label:'HeaderTeam'}),
        ColumnResult({label: 'HeaderPoints'}),
        ColumnExpander({})
    ]
    return (
        columns
    )
}

export default TableColumns

